/**
 * Get new case size to be selected when current case size is not available in the new selected color
 */
export const getNewSelectedCaseSize = (availableCaseSizes: string[], currentCaseSize: string): string => {
    const numericCaseSizes = availableCaseSizes.map(caseSize => ({
        label: caseSize,
        numericCaseSize: getNumericCaseSize(caseSize),
    }));
    const numericCurrentCaseSize = {
        label: currentCaseSize,
        numericCaseSize: getNumericCaseSize(currentCaseSize),
    };

    let newCaseSize: string;
    const minCaseSize = Math.min(...numericCaseSizes.map(caseSize => caseSize.numericCaseSize));
    const maxCaseSize = Math.max(...numericCaseSizes.map(caseSize => caseSize.numericCaseSize));

    switch (true) {
        case (availableCaseSizes.some(caseSize => caseSize === currentCaseSize)):
            newCaseSize = currentCaseSize;
            break;
        case (numericCurrentCaseSize.numericCaseSize > maxCaseSize):
            newCaseSize = availableCaseSizes[numericCaseSizes.findIndex(caseSize => caseSize.numericCaseSize === maxCaseSize)];
            break;
        case (numericCurrentCaseSize.numericCaseSize < minCaseSize):
            newCaseSize = availableCaseSizes[numericCaseSizes.findIndex(caseSize => caseSize.numericCaseSize === minCaseSize)];
            break;
        default:
            // Get next bigger case size
            newCaseSize = availableCaseSizes[numericCaseSizes
                .findIndex(caseSize => caseSize.numericCaseSize > numericCurrentCaseSize.numericCaseSize)];
            break;
    }

    return newCaseSize;
};

const getNumericCaseSize = (caseSize: string): number => parseInt(caseSize.match(/\d+/)![0], 10);
